module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-book-webfont.051d4116.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-book-webfont.eot
// module id = 96
// module chunks = 3